export const DEFAULT_TAX_SETTINGS = Object.freeze({
  enabled: false,
  gstin: '',
  defaultRate: 18,
  supplyType: 'intra_state',
  priceIncludesTax: false,
  applyTo: {
    storage: true,
    crateRent: true,
    grading: true,
    packing: true,
    labour: true,
    handling: true,
    unloading: true,
    weighment: true,
    other: true,
  },
});

export const normalizeTaxSettings = (value = {}) => {
  const raw = value || {};
  const applyTo = { ...DEFAULT_TAX_SETTINGS.applyTo, ...(raw.applyTo || {}) };
  const defaultRate = Number(raw.defaultRate ?? raw.gstRate ?? DEFAULT_TAX_SETTINGS.defaultRate);
  return {
    ...DEFAULT_TAX_SETTINGS,
    ...raw,
    enabled: raw.enabled === true,
    gstin: String(raw.gstin || raw.gstNumber || '').trim().toUpperCase(),
    defaultRate: Number.isFinite(defaultRate) ? Math.max(0, Math.min(100, defaultRate)) : 18,
    supplyType: ['intra_state','inter_state'].includes(raw.supplyType) ? raw.supplyType : 'intra_state',
    priceIncludesTax: raw.priceIncludesTax === true,
    applyTo,
  };
};

export const taxRateForCharge = (taxSettings, chargeType = 'other') => {
  const settings = normalizeTaxSettings(taxSettings);
  if (!settings.enabled) return 0;
  const keyMap = {
    storage: 'storage', storage_charge: 'storage',
    crate: 'crateRent', crate_rent: 'crateRent', crateRent: 'crateRent',
    grading: 'grading', packing: 'packing', labour: 'labour', handling: 'handling',
    unloading: 'unloading', weighment: 'weighment', other: 'other',
  };
  const key = keyMap[chargeType] || 'other';
  return settings.applyTo?.[key] === false ? 0 : settings.defaultRate;
};

export default normalizeTaxSettings;
